'use client';

// npm packages
import React, { useEffect, useRef, useState } from 'react';
import { SwiperSlide } from 'swiper/react';
import { useDispatch, useSelector } from 'react-redux';
import { usePathname } from 'next/navigation';

// swiper slider
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import './custom_scrollbar.css';

// utils
import { SENATE, TITAN_WHITE } from '@/constants';
import { cn } from '@/utils/cn';

// components
import Icon from '@/app/components/Icon';
import ProductCardV2 from '@/app/components/Card/ProductCardV2';
import { addViewedProducts } from '@/redux/thunk/recently-viewed-thunk';
import { sliderMainClassTypes, sliderNavigationTypes } from '@/constants/types';
import SliderWrapper from '../Wrapper/SliderWrapper';

function RecentlyViewedSlider({ setShowTitle = () => {} }) {
  const pathname = usePathname();
  const dispatch = useDispatch();
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [arrowPrevColor, setArrowPrevColor] = useState(SENATE);
  const [arrowNextColor, setArrowNextColor] = useState(SENATE);
  // TODO: need to add
  const { currentParentProductDetail } = useSelector(
    (state) => state.productDetail,
  );
  const { items: recentViewedItems } = useSelector(
    (state) => state.recentlyViewed,
  );
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (isLoggedIn && recentViewedItems?.length > 0) {
      dispatch(addViewedProducts(recentViewedItems));
    }
    if (pathname?.startsWith('/product/')) {
      const updatedList = recentViewedItems?.filter(
        (product) => product.id !== currentParentProductDetail?.product?.id,
      );
      if (updatedList?.length === 0) {
        setShowTitle(false);
      }
      setItems(updatedList);
      return;
    }
    setItems(recentViewedItems);
  }, [recentViewedItems]);

  const isPDP = () => pathname.startsWith('/product/');

  return (
    <SliderWrapper
      outerDivClass="h-auto mb-24 lg:mb-40 relative"
      containerRefClass={cn(
        'container mx-auto',
        // isPDP() && '3xl:max-w-[1720px]',
        // !isPDP() && '3xl:max-w-[1440px]',
      )}
      sliderMainClassType={sliderMainClassTypes.justForYou}
      sliderNavigationType={sliderNavigationTypes.withNavigation}
      prevButtonRef={prevRef}
      nextButtonRef={nextRef}
    >
      {Array.isArray(items) && items?.length > 0
        ? items?.map((item, index) => (
            <SwiperSlide
              key={item?.id ?? index}
              className="w-full max-w-[180px] lg:max-w-[298px]"
            >
              <ProductCardV2 key={item?.id ?? index} data={item} />
            </SwiperSlide>
          ))
        : null}
      {/* navigation button */}
      <div
        ref={prevRef}
        className="swiper-button-prev !flex justify-center items-center !w-[36px] !h-[36px] bg-titanwhite rounded-full shadow-product-slider-shadow"
        onMouseEnter={() => setArrowPrevColor(TITAN_WHITE)}
        onMouseLeave={() => setArrowPrevColor(TITAN_WHITE)}
      >
        <Icon
          type="angle-right2"
          color={arrowPrevColor}
          className="!w-[24px] !h-[24px] -rotate-180"
        />
      </div>
      <div
        ref={nextRef}
        className="recently-viewed-slider swiper-button-next !right-0 !flex justify-center items-center !w-[36px] !h-[36px] bg-titanwhite rounded-full shadow-product-slider-shadow"
        onMouseEnter={() => setArrowNextColor(TITAN_WHITE)}
        onMouseLeave={() => setArrowNextColor(TITAN_WHITE)}
      >
        <Icon
          type="angle-right2"
          color={arrowNextColor}
          className="!w-[24px] !h-[24px]"
        />
      </div>
    </SliderWrapper>
  );
}

export default RecentlyViewedSlider;
